import { defineMessages } from 'react-intl';

export default defineMessages({
  settings: {
    id: 'cboard.components.Settings.settings',
    defaultMessage: 'Settings'
  },
  people: {
    id: 'cboard.components.Settings.people',
    defaultMessage: 'People'
  },
  subscribe: {
    id: 'cboard.components.Settings.subscribe',
    defaultMessage: 'Subscribe'
  },
  guest: {
    id: 'cboard.components.Settings.guest',
    defaultMessage: 'Guest'
  },
  language: {
    id: 'cboard.components.Settings.language',
    defaultMessage: 'Language'
  },
  speech: {
    id: 'cboard.components.Settings.speech',
    defaultMessage: 'Speech'
  },
  export: {
    id: 'cboard.components.Settings.export',
    defaultMessage: 'Export'
  },
  import: {
    id: 'cboard.components.Settings.import',
    defaultMessage: 'Import'
  },
  display: {
    id: 'cboard.components.Settings.display',
    defaultMessage: 'Display'
  },
  scanning: {
    id: 'cboard.components.Settings.scanning',
    defaultMessage: 'Scanning'
  },
  navigation: {
    id: 'cboard.components.Settings.navigation',
    defaultMessage: 'Navigation'
  },
  system: {
    id: 'cboard.components.Settings.system',
    defaultMessage: 'System'
  },
  about: {
    id: 'cboard.components.Settings.about',
    defaultMessage: 'About Cboard'
  },
  feedback: {
    id: 'cboard.components.Settings.feedback',
    defaultMessage: 'Feedback'
  },
  donate: {
    id: 'cboard.components.Settings.donate',
    defaultMessage: 'Donate'
  },
  username: {
    id: 'cboard.components.Settings.username',
    defaultMessage: 'Username'
  },
  loginSignup: {
    id: 'cboard.components.Settings.loginSignup',
    defaultMessage: 'Login / Sign Up'
  },
  logout: {
    id: 'cboard.components.Settings.logout',
    defaultMessage: 'Logout'
  },
  help: {
    id: 'cboard.components.Settings.help',
    defaultMessage: 'Help'
  },
  userHelp: {
    id: 'cboard.components.Settings.userHelp',
    defaultMessage: 'User Help'
  },
  walkthroughEndTour: {
    id: 'cboard.components.Settings.walkthroughEndTour',
    defaultMessage: 'End Tour'
  },
  walkthroughCloseTour: {
    id: 'cboard.components.Settings.walkthroughCloseTour',
    defaultMessage: 'Close Tour'
  },
  walkthroughBack: {
    id: 'cboard.components.Settings.walkthroughBack',
    defaultMessage: 'Back'
  },
  walkthroughNext: {
    id: 'cboard.components.Settings.walkthroughNext',
    defaultMessage: 'Next'
  },
  walkthroughSettings: {
    id: 'cboard.components.Settings.walkthroughSettings',
    defaultMessage: 'Welcome to the settings!'
  },
  walkthroughSettingsDesc: {
    id: 'cboard.components.Settings.walkthroughSettingsDesc',
    defaultMessage:
      'The settings allows you to configure Cboard according to your needs. You can change the language, voice, look and feel, elements sizes, enable scanning and many more. '
  },
  walkthroughLanguage: {
    id: 'cboard.components.Settings.walkthroughLanguage',
    defaultMessage: 'Select a language for your profile.'
  },
  walkthroughSpeech: {
    id: 'cboard.components.Settings.walkthroughSpeech',
    defaultMessage:
      'Select the speech settings for your profile. You can change the voice, the pitch and the rate.'
  },
  walkthroughExport: {
    id: 'cboard.components.Settings.walkthroughExport',
    defaultMessage:
      'Browse options to export your Cboard boards to use them offline.'
  },
  walkthroughImport: {
    id: 'cboard.components.Settings.walkthroughImport',
    defaultMessage: 'Click here to import or upload your own boards.'
  },
  uiSizeTitle: {
    id: 'cboard.components.Settings.uiSizeTitle',
    defaultMessage: 'User Interface size'
  },
  uiSizeDescrip: {
    id: 'cboard.components.Settings.uiSizeDescrip',
    defaultMessage:
      'Edit the size of the tiles here by choosing between: 1. Standard - 2. Large - 3. Extra Large'
  },
  fontSizeTitle: {
    id: 'cboard.components.Settings.fontSizeTitle',
    defaultMessage: 'Font Size'
  },
  fontSizeDescrip: {
    id: 'cboard.components.Settings.fontSizeDescrip',
    defaultMessage:
      'Edit font size here by selecting from: 1. Standard, 2. Large or 3. Extra Large.'
  },
  hideOutputBarTitle: {
    id: 'cboard.components.Settings.hideOutputBarTitle',
    defaultMessage: 'Hide the output bar'
  },
  hideOutputBarDescrip: {
    id: 'cboard.components.Settings.hideOutputBarDescrip',
    defaultMessage:
      'Hides the white bar on the top of the screen where icons appear when you build a sentence or select pictograms.'
  },
  labelPositionTitle: {
    id: 'cboard.components.Settings.labelPositionTitle',
    defaultMessage: 'Label position'
  },
  labelPositionDescrip: {
    id: 'cboard.components.Settings.labelPositionDescrip',
    defaultMessage:
      'You can choose where to position the label. It can be above, below or hidden.'
  },
  enableDarkThemeTitle: {
    id: 'cboard.components.Settings.enableDarkThemeTitle',
    defaultMessage: 'Enable dark theme'
  },
  enableDarkThemeDescrip: {
    id: 'cboard.components.Settings.enableDarkThemeDescrip',
    defaultMessage: 'Click here to change the screen to a black background.'
  },
  enableScanningTitle: {
    id: 'cboard.components.Settings.enableScanningTitle',
    defaultMessage: 'Scanning'
  },
  enableScanningDescrip: {
    id: 'cboard.components.Settings.enableScanningDescrip',
    defaultMessage:
      'Scanning is where the items on your board are automatically selected sequentially over time and the user makes a selection indirectly by pressing any key. The scanning can be automatic, manual or have a time delay (users can select how much time). This feature may help users with limited mobility.'
  },
  enableContextAwareBackButtonTitle: {
    id: 'cboard.components.Settings.enableContextAwareBackButtonTitle',
    defaultMessage: 'Context aware back button'
  },
  enableContextAwareBackButtonDescrip: {
    id: 'cboard.components.Settings.enableContextAwareBackButtonDescrip',
    defaultMessage: 'Add a large orange back button to your boards.'
  },
  showSharePhraseButtonTitle: {
    id: 'cboard.components.Settings.showSharePhraseButtonTitle',
    defaultMessage: 'Add a share button'
  },
  showSharePhraseButtonDescrip: {
    id: 'cboard.components.Settings.showSharePhraseButtonDescrip',
    defaultMessage:
      'Add a share button that allow sharing your selected symbols/sentence in the top white bar above your board.'
  },
  removeSymbolsFromTheOutputBarTitle: {
    id: 'cboard.components.Settings.removeSymbolsFromTheOutputBarTitle',
    defaultMessage: 'Delete symbols from the output bar'
  },
  removeSymbolsFromTheOutputBarDescrip: {
    id: 'cboard.components.Settings.removeSymbolsFromTheOutputBarDescrip',
    defaultMessage:
      '"X" button on each symbol allows the user to delete pictograms from the output bar.'
  },
  folderVocalizationTitle: {
    id: 'cboard.components.Settings.folderVocalizationTitle',
    defaultMessage: 'Folder vocalization'
  },
  folderVocalizationDescrip: {
    id: 'cboard.components.Settings.folderVocalizationDescrip',
    defaultMessage: 'Reads folders name out loud when clicked'
  },
  enableTour: {
    id: 'cboard.components.Settings.enableTour',
    defaultMessage: 'Enable tour'
  },
  symbols: {
    id: 'cboard.components.Settings.symbols',
    defaultMessage: 'Symbols'
  }
});
